import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import Content from 'modules/timeoff/components/MedicalLeaveContent'
// Hooks
import useFetchLeave from 'modules/timeoff/hooks/useFetchLeave'

import useCreateMedicalLeaveUpdate from './useCreateMedicalLeaveUpdate'

const getSubmitCopyLabel = (type: string) => {
  switch (type) {
    case 'medical_confirmation':
      return i18n.t('time_off.medical_leave.updates.submit_copy.medical_confirmation')
    case 'medical_discharge':
      return i18n.t('time_off.medical_leave.updates.submit_copy.medical_discharge')
    case 'medical_hospital_stay':
      return i18n.t('time_off.medical_leave.updates.submit_copy.medical_hospital_stay')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

const getTypesLabel = (type: string) => {
  switch (type) {
    case 'medical_confirmation':
      return i18n.t('time_off.medical_leave.updates.types.medical_confirmation')
    case 'medical_discharge':
      return i18n.t('time_off.medical_leave.updates.types.medical_discharge')
    case 'medical_hospital_stay':
      return i18n.t('time_off.medical_leave.updates.types.medical_hospital_stay')
    case 'medical_leave_start':
      return i18n.t('time_off.medical_leave.updates.types.medical_leave_start')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

interface Props {
  leaveId: number
  onClose: () => void
  contractVersions: ContractVersions
  loading: boolean
}

const NewMedicalLeaveUpdatePage = ({ leaveId, onClose, contractVersions, loading }: Props) => {
  const { leave, employee } = useFetchLeave({
    leaveId,
    onClose,
  })

  const leaveUpdate = useCreateMedicalLeaveUpdate({
    employee,
    leave,
    onClose,
  })

  const leaveType = leaveUpdate.form.get('leave_update_type').value
  const type = getTypesLabel(leaveType ?? '')
  const title = i18n.t('time_off.medical_leave.updates.title_modal')

  const description = i18n.t('time_off.medical_leave.updates.new_modal.description', {
    type,
  })

  const buttonLabel = getSubmitCopyLabel(leaveType ?? '')

  return (
    <Modal
      illustration="user-tie"
      title={title}
      description={description}
      onClose={onClose}
      onSubmit={leaveUpdate.onSubmit}
      footer={<Button submit>{buttonLabel}</Button>}
    >
      {loading ? (
        <Loading />
      ) : (
        <Content
          form={leaveUpdate.form}
          medicalLeaveType={leave.attributes.medical_leave_type}
          minEffectiveOn={leaveUpdate.minEffectiveOn}
          contractVersions={contractVersions}
        />
      )}
    </Modal>
  )
}

export default observer(NewMedicalLeaveUpdatePage)
